import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer({}, {

    [actions.LOAD_LIGHT_STOMPUNKTER_SUCCESS]: (state, action) => ({
    	...state,
    	...action.stompunkter,
    }),

    [actions.LOAD_HEAVY_STOMPUNKTER_SUCCESS]: (state, action) => ({
    	...state,
    	...action.stompunkter.lightSystem,
    }),

})


// WEBPACK FOOTER //
// ./src/reducers/lightStompunkter.js